"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CanvasCartesian2dAxisLabelGraphicsComponent = void 0;
const core_1 = require("@visualization-tools/core");
const cartesian_2d_axis_label_generator_1 = require("./cartesian-2d-axis-label-generator");
/**
 * @public
 * Draws labels for cartesian 2d plots.
 */
class CanvasCartesian2dAxisLabelGraphicsComponent {
    constructor(attachPoint, axisLabelGenerator = new cartesian_2d_axis_label_generator_1.Cartesian2dAxisLabelGenerator(attachPoint)) {
        this.axisLabelGenerator = axisLabelGenerator;
        this.type = core_1.EGraphicsComponentType.Entity;
        this.specification = {};
        this.transform = new core_1.NoTransformProvider();
    }
    getCacheId() {
        return "CanvasAxisGraphicsComponent";
    }
    initialize() {
        // no action needed
    }
    onBeforeUpdate() {
        // no action needed
    }
    update(entity, componentRenderer, updateArg) {
        const context = componentRenderer.context;
        const dataToCanvasTransform = updateArg.drawTransforms.dataToInteractiveArea;
        const userTransform = updateArg.userTransform;
        const lookup = this.axisLabelGenerator.update(entity, updateArg.canvasDimensions.dpr);
        const canvas = this.axisLabelGenerator.getCanvas();
        const paddingXAxis = entity.graphicsSettings.axisOptions.padding * updateArg.canvasDimensions.dpr;
        const graphY = dataToCanvasTransform.getVec3MultiplyY(updateArg.transformedDataRange.getYMin());
        context.save();
        for (let i = 0, iEnd = entity.data.getXTraceCount(); i < iEnd; ++i) {
            const graphX = dataToCanvasTransform.getVec3MultiplyX(userTransform.forwardX(entity.data.getXTick(i)));
            const spriteX = core_1.SpriteLookup.getXAtIndex(lookup, i);
            const spriteY = core_1.SpriteLookup.getYAtIndex(lookup, i);
            const spriteWidth = core_1.SpriteLookup.getWidthAtIndex(lookup, i);
            const spriteHeight = core_1.SpriteLookup.getHeightAtIndex(lookup, i);
            context.drawImage(canvas, 
            // position in sprite
            spriteX, spriteY, spriteWidth, spriteHeight, 
            // position in graph
            graphX - spriteWidth * 0.5, // center about the trace
            graphY + paddingXAxis, spriteWidth, spriteHeight);
        }
        const xTraceCount = entity.data.getXTraceCount();
        const graphX = dataToCanvasTransform.getVec3MultiplyX(updateArg.transformedDataRange.getXMin());
        const paddingYAxis = entity.graphicsSettings.axisOptions.padding * updateArg.canvasDimensions.dpr;
        for (let i = 0, iEnd = entity.data.getYTraceCount(); i < iEnd; ++i) {
            const spriteIndex = xTraceCount + i;
            const graphY = dataToCanvasTransform.getVec3MultiplyY(userTransform.forwardY(entity.data.getYTick(i)));
            const spriteX = core_1.SpriteLookup.getXAtIndex(lookup, spriteIndex);
            const spriteY = core_1.SpriteLookup.getYAtIndex(lookup, spriteIndex);
            const spriteWidth = core_1.SpriteLookup.getWidthAtIndex(lookup, spriteIndex);
            const spriteHeight = core_1.SpriteLookup.getHeightAtIndex(lookup, spriteIndex);
            context.drawImage(canvas, 
            // position in sprite
            spriteX, spriteY, spriteWidth, spriteHeight, 
            // position in graph
            graphX - spriteWidth - paddingYAxis, graphY - spriteHeight * 0.5, // center about the trace
            spriteWidth, spriteHeight);
        }
        context.restore();
    }
}
exports.CanvasCartesian2dAxisLabelGraphicsComponent = CanvasCartesian2dAxisLabelGraphicsComponent;
//# sourceMappingURL=canvas-cartesian-2d-axis-label-graphics-component.js.map